<template>
    <div class="login-page">
        <div class="login-page-mark" />
        <div class="login-page-form">
            <div class="login-page-title">
                <span>{{ title }}</span>
            </div>
            <div class="login-page-form-logo">
                <img :src="logo">
            </div>
            <div class="login-select-content">
                <div :class="{ 'show-options-arrow': showOptions }">
                    <input
                        type="text"
                        readonly
                        :value="selectLabel"
                        @click="selectClick"
                    >
                </div>
                <transition name="select">
                    <ul v-show="showOptions" class="select-list">
                        <li v-for="(item, index) in options" :key="index" @click="optionClick(item)">
                            {{ item.label }}
                        </li>
                    </ul>
                </transition>
            </div>
            <form @submit.prevent="onSubmit">
                <ul class="login-form-content">
                    <li>
                        <img src="../assets/images/login/u2637.png" alt="">
                        <input
                            v-model="form.account"
                            type="text"
                            placeholder="请输入账号"
                        >
                    </li>
                    <li>
                        <img src="../assets/images/login/u2641.png" alt="">
                        <input
                            v-model="form.password"
                            type="password"
                            placeholder="请输入密码"
                        >
                    </li>
                    <li v-if="needVerifyCode">
                        <input v-model="form.verifyCode" placeholder="验证码" name="code">
                        <div class="verification-code-show">
                            <img :src="codeImg">
                        </div>
                    </li>
                </ul>
                <button class="login-btn" type="submit">登录</button>
            </form>

            <div class="login-protocol">
                <van-checkbox
                    v-model="agree"
                    icon-size="16"
                >同意<a @click.stop="goToAgreement">《{{ title }}用户使用协议》</a>手册</van-checkbox>
            </div>
        </div>
        <img src="../assets/icon/u2640.png" class="login-page-back" @click="back">
    </div>
</template>

<script>
    const mixin = require(`@/config/${process.env.VUE_APP_PROJECT}/login`)
    import { Form, Field, Button, Checkbox } from 'vant'
    export default {
        components: {
            [Form.name]: Form,
            [Field.name]: Field,
            [Button.name]: Button,
            [Checkbox.name]: Checkbox,
        },
        mixins: [mixin],
        data() {
            return {
                codeImg: '',
                showOptions: false,
                link: 'javascirpt;',
                agree: false,
            }
        },
        computed: {
            logo() {
                return require(`@/config/${process.env.VUE_APP_PROJECT}/images/logo.png`)
            },
        },
        mounted() {
            if (this.needVerifyCode) {
                this.verifyCodeUid()
            }
        },
        methods: {
            onSubmit() {
                if (!this.agree) {
                    this.$ZlmToast(
                        '请勾选并仔细阅读《安徽交控招标采购平台用户使用协议》手册',
                    )
                    return
                }
                if (!this.checkForm()) {
                    return
                }
                this.login(this.form)
            },

            checkForm() {
                const { account, password, verifyCode } = this.form
                if (!account) {
                    this.$ZlmToast('请输入账号')
                    return false
                }

                if (!password) {
                    this.$ZlmToast('请输入密码')
                    return false
                }

                if (!verifyCode && this.needVerifyCode) {
                    this.$ZlmToast('请输入验证码')
                    return false
                }
                return true
            },

            back() {
                this.$router.push('/')
            },

            optionClick(data) {
                this.selectLabel = data.label
                this.showOptions = false
            },

            selectClick() {
                this.showOptions = !this.showOptions
            },
            /**
             * 前往用户协议
             * */
            goToAgreement() {
                this.$router.push({
                    name: 'Agreement',
                })
            },
        },
    }
</script>

<style lang="scss">
$--md-fade-transition: transform 300ms cubic-bezier(0.23, 1, 0.32, 1),
opacity 300ms cubic-bezier(0.23, 1, 0.32, 1) !default;

.login-select-content {
    margin: 20px auto;
    text-align: center;
    position: relative;
    > div {
        position: relative;
        display: inline-block;
        &:after {
            content: "";
            position: absolute;
            right: 10px;
            top: 9px;
            width: 6px;
            height: 12px;
            background: url("../assets/images/login/u232.png");
            background-size: cover;
            transform: rotate(-90deg);
        }
    }

    .show-options-arrow:after {
        transform: rotate(90deg);
    }
    input {
        width: 180px;
        height: 32px;
        border-radius: 6px;
        padding: 0 12px;
        border: none;
        background: #fff;
        outline: none;
    }

    .select-list {
        position: absolute;
        top: 32px;
        width: 180px;
        left: 50%;
        transform: translateX(-50%);
        background: #fff;
        border: 1px solid #cfcfcf;
        border-radius: 6px;
        padding: 0 12px;
        z-index: 1001;
    }

    li {
        height: 30px;
        line-height: 30px;
        font-size: 14px;

        &:not(:last-child) {
            border-bottom: 1px solid #cfcfcf;
        }
    }
}

.select-enter-active,
.select-leave-active {
    opacity: 1;
    transform: scaleY(1);
    transition: $--md-fade-transition;
    transform-origin: center top;
}

.select-enter,
.select-leave-active {
    opacity: 0;
    transform: scaleY(0);
}

.login-form-content {
    margin-top: 32px;

    > li {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 32px;

        img {
            width: 20px;
            height: 20px;
            margin-right: 12px;
        }

        > input {
            padding: 0 16px;
            width: 180px;
            height: 32px;
            background: rgba(255, 255, 255, 0.2);
            border: none;
            border-radius: 16px;
            color: #cacaca;
        }

        .verification-code-show img{
            max-height: 45px;
            min-width: 60px;
            display: block;
            margin: auto;
            border-radius: 3px;
            background: rgba(177, 177, 177, 0.1);
        }
    }
}

.login-btn {
    width: 280px;
    height: 48px;
    margin-top: 60px;
    text-align: center;
    background: linear-gradient(
            180deg,
            rgba(0, 165, 255, 1) 0%,
            rgba(0, 46, 147, 1) 100%
    );
    border: none;
    outline: none;
    color: #f1e5e5;
    font-size: 16px;
    border-radius: 8px;
}

.login-protocol {
    margin-top: 80px;
    .van-checkbox__label {
        color: #fff;
    }
    a {
        color: #00e0fc;
        text-decoration: none;
    }
}

.login-page {
    background: $background-url no-repeat;
    background-size: cover;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    &-back {
        position: absolute;
        top: 21px;
        left: 20px;
        width: 21px;
        z-index: 9999;
    }
    &-mark {
        border-width: 0px;
        position: absolute;
        left: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        background-color: rgba(7, 10, 80, 0.5);
        border: none;
        border-radius: 0px;
        box-shadow: none;
    }
    &-title {
        font-size: 20px;
        color: #ffffff;
        text-align: center;
        margin-bottom: 20px;
    }
    &-form {
        z-index: 1;
        &-logo {
            height: 64px;
            width: 64px;
            border-radius: 10px;
            margin-left: 50%;
            transform: translateX(-50%);
            background: #ffffff;
            margin-bottom: 20px;
            img {
                height: 64px;
                width: 64px;
            }
        }
        .van-cell {
            background-color: rgba(255, 255, 255, 1);
            border-radius: 20px;
        }
        & form {
            text-align: center;
        }
    }
}
</style>
